import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { callAPIWithoutAuth } from '../../utils/apiUtils';
import { apiUrls } from '../../utils/apiUrls';

const dummyProducts = [
  {
    id: 1,
    image: "/image/item-1.png",
    brand: "Continental",
    name: "Premium All-Season Tire - Continental TrueContact",
    rating: 5,
    reviews: 128,
    price: 145.99,
    discount: 30,
    isFavorite: false,
    category: "tires",
    tireSize: "205/55R16",
    carModel: "sedan"
  },
  {
    id: 2,
    image: "/image/item-2.png",
    brand: "Michelin",
    name: "Performance Winter Tire - Michelin X-Ice",
    rating: 4,
    reviews: 89,
    price: 189.99,
    discount: 15,
    isFavorite: false,
    category: "tires",
    tireSize: "225/45R17",
    carModel: "suv"
  },
  {
    id: 3,
    image: "/image/item-3.png",
    brand: "Bridgestone",
    name: "Turanza T005 - Quiet Comfort Touring",
    rating: 4,
    reviews: 56,
    price: 135.50,
    discount: 0,
    isFavorite: false,
    category: "tires",
    tireSize: "195/65R15",
    carModel: "sedan"
  },
  {
    id: 4,
    image: "/image/item-4.png",
    brand: "Pirelli",
    name: "P Zero - Ultra High Performance",
    rating: 5,
    reviews: 203,
    price: 249.99,
    discount: 20,
    isFavorite: false,
    category: "tires",
    tireSize: "245/40R18",
    carModel: "sports"
  },
  {
    id: 5,
    image: "/image/item-5.png",
    brand: "Goodyear",
    name: "EfficientGrip Performance SUV",
    rating: 4,
    reviews: 67,
    price: 169.99,
    discount: 10,
    isFavorite: false,
    category: "tires",
    tireSize: "235/55R18",
    carModel: "suv"
  },
  {
    id: 6,
    image: "/image/item-6.png",
    brand: "Continental",
    name: "ExtremeContact DWS06 Plus",
    rating: 5,
    reviews: 312,
    price: 165.99,
    discount: 25,
    isFavorite: false,
    category: "tires",
    tireSize: "225/50R17",
    carModel: "sedan"
  },
  {
    id: 7,
    image: "/image/item-7.png",
    brand: "Michelin",
    name: "Defender T+H All-Season",
    rating: 5,
    reviews: 456,
    price: 155.50,
    discount: 20,
    isFavorite: false,
    category: "tires",
    tireSize: "205/60R16",
    carModel: "sedan"
  },
  {
    id: 8,
    image: "/image/item-8.png",
    brand: "BFGoodrich",
    name: "All-Terrain T/A KO2",
    rating: 5,
    reviews: 289,
    price: 215.99,
    discount: 15,
    isFavorite: false,
    category: "tires",
    tireSize: "265/70R17",
    carModel: "truck"
  },
  {
    id: 9,
    image: "/image/item-1.png",
    brand: "Pirelli",
    name: "Scorpion Verde All-Season",
    rating: 4,
    reviews: 178,
    price: 199.99,
    discount: 10,
    isFavorite: false,
    category: "tires",
    tireSize: "255/55R18",
    carModel: "suv"
  },
  {
    id: 10,
    image: "/image/item-2.png",
    brand: "Yokohama",
    name: "Advan Sport V105",
    rating: 4,
    reviews: 145,
    price: 179.99,
    discount: 20,
    isFavorite: false,
    category: "tires",
    tireSize: "225/40R18",
    carModel: "sports"
  }
];

const dummyBrands = [
  { id: 1, name: "Continental" },
  { id: 2, name: "Michelin" },
  { id: 3, name: "Bridgestone" },
  { id: 4, name: "Pirelli" },
  { id: 5, name: "Goodyear" },
  { id: 6, name: "BFGoodrich" },
  { id: 7, name: "Yokohama" }
];

const dummyCarModels = [
  { id: 1, name: "Sedan" },
  { id: 2, name: "SUV" },
  { id: 3, name: "Sports" },
  { id: 4, name: "Truck" },
  { id: 5, name: "Coupe" },
  { id: 6, name: "Hatchback" }
];

const dummyTireSizes = [
  { id: 1, name: "195/65R15" },
  { id: 2, name: "205/55R16" },
  { id: 3, name: "205/60R16" },
  { id: 4, name: "225/45R17" },
  { id: 5, name: "225/50R17" },
  { id: 6, name: "225/40R18" },
  { id: 7, name: "235/55R18" },
  { id: 8, name: "245/40R18" },
  { id: 9, name: "255/55R18" },
  { id: 10, name: "265/70R17" }
];

export const fetchBrands = createAsyncThunk(
  'productListing/fetchBrands',
  async (categoryId, { rejectWithValue }) => {
    try {
      const response = await callAPIWithoutAuth(
        `${apiUrls?.brandsListing}`,
        { categoryId },
        "GET",
        {}
      );

      if (response?.data?.success) {
        return response.data.data;
      } else {
        return rejectWithValue(response?.data?.message || 'Failed to fetch brands');
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Network error');
    }
  }
);

export const fetchTireSizes = createAsyncThunk(
  'productListing/fetchTireSizes',
  async (_, { rejectWithValue }) => {
    try {
      const response = await callAPIWithoutAuth(
        apiUrls?.sizesListing,
        {},
        "GET",
        {}
      );

      if (response?.data?.success) {
        return response.data.data;
      } else {
        return rejectWithValue(response?.data?.message || 'Failed to fetch tire sizes');
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Network error');
    }
  }
);

export const fetchModelsByBrand = createAsyncThunk(
  'productListing/fetchModelsByBrand',
  async (brandId, { rejectWithValue }) => {
    try {
      if (!brandId || brandId === '') {
        return {
          brandId: '',
          models: []
        };
      }
      const response = await callAPIWithoutAuth(
        `${apiUrls?.brandModelsListing}`,
        { brand_id: brandId },
        "GET",
        {}
      );

      if (response?.data?.success) {
        return {
          brandId,
          models: response.data.data
        };
      } else {
        return rejectWithValue(response?.data?.message || 'Failed to fetch models');
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Network error');
    }
  }
);

export const fetchProducts = createAsyncThunk(
  'productListing/fetchProducts',
  async ({
    page = 1,
    limit = 10,
    brand = '',
    model = '',
    tireSize = '',
    category = '',
    sort = '',
    user_id = '',
    search = ''
  } = {}, { rejectWithValue }) => {
    try {
      const params = new URLSearchParams();
      params.append('page', page);
      params.append('per_page', limit);

      console.log("brand ", brand, "model ", model)

      if (category) {
        params.append('category_id', category);
      }

      if (brand) {
        params.append('brand_id[]', brand);
      }
      if (model) {
        params.append('model_id[]', model);
      }
      if (tireSize) {
        params.append('size_id', tireSize);
      }
      params.append('search', search);
      if (user_id) {
        params.append('user_id', user_id)
      }
      if (sort) {
        params.append('sort_by', sort);
      }

      const queryString = params.toString();
      console.log('API Request with filters:', Object.fromEntries(params)); // For debugging

      const response = await callAPIWithoutAuth(
        `${apiUrls.productListing}?${queryString}`,
        {},
        "GET",
        {}
      );

      if (response?.data?.success) {
        const apiData = response.data.data;

        const transformedProducts = apiData.data?.map(product => {
          let price = 0;
          let discountedPrice = 0;
          let variantType = '';
          let productImage = "";

          if (product.tyre_variants?.length > 0) {
            const variant = product.tyre_variants[0];
            price = variant.price;
            discountedPrice = variant.discounted_price;
            variantType = 'tyre';
            if (variant.images?.length > 0) {
              productImage = variant.images[0].image_url;
            }
            else {
              productImage = product.category.image_url
            }
          } else if (product.battery_variants?.length > 0) {
            const variant = product.battery_variants[0];
            price = variant.price;
            discountedPrice = variant.discounted_price;
            variantType = 'battery';
            if (variant.images?.length > 0) {
              productImage = variant.images[0].image_url;
            }
            else {
              productImage = product.category.image_url
            }
          } else if (product.windshield_variants?.length > 0) {
            const variant = product.windshield_variants[0];
            price = variant.price;
            discountedPrice = variant.discounted_price;
            variantType = 'windshield';
            if (variant.images?.length > 0) {
              productImage = variant.images[0].image_url;
            }
            else {
              productImage = product.category.image_url
            }
          }

          const discount = price > 0 && discountedPrice
            ? Math.round(((price - discountedPrice) / price) * 100)
            : 0;

          return {
            id: product.id,
            image: productImage,
            categoryId: product?.category_id,
            brand: product.brand?.name || "Unknown",
            brandImage: product.brand.image_url,
            img: product.category.image_url,
            name: product.name,
            rating: 4,
            reviews: 0,
            price: parseFloat(price) || 0,
            badge: product.badge,
            discount: discount,
            discountedPrice: discountedPrice || parseFloat(price),
            is_saved: product.is_saved || false,
            isFavorite: product.is_saved || false,
            category: product.category?.title?.toLowerCase() || "",
            tireSize: product.size?.name || "",
            carModel: product.model?.name || "",
            variantType: variantType,
            variants: product.tyre_variants || product.battery_variants || product.windshield_variants || [],
            reviews_count: product.reviews_count,
            reviews_avg_rating: product.reviews_avg_rating
          };
        }) || [];

        return {
          products: transformedProducts,
          totalResults: apiData.total || 0,
          currentPage: apiData.current_page || page,
          itemsPerPage: apiData.per_page || limit,
          totalPages: apiData.last_page || 1,
          isDefault: true
        };
      } else {
        return rejectWithValue(response?.data?.message || 'Failed to fetch products');
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Network error');
    }
  }
);

export const fetchFilterOptions = createAsyncThunk(
  'productListing/fetchFilterOptions',
  async (categoryId, { dispatch, rejectWithValue }) => {
    try {
      const [brandsResult, sizesResult] = await Promise.all([
        dispatch(fetchBrands(categoryId)).unwrap(),
        dispatch(fetchTireSizes()).unwrap()
      ]);

      return {
        brands: brandsResult,
        tireSizes: sizesResult,
        carModels: []
      };
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch filter options');
    }
  }
);

export const fetchProductById = createAsyncThunk(
  'productListing/fetchProductById',
  async (productId, { rejectWithValue }) => {
    try {
      await new Promise(resolve => setTimeout(resolve, 300));

      const product = dummyProducts.find(p => p.id === parseInt(productId));

      if (!product) {
        return rejectWithValue('Product not found');
      }

      return product;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch product');
    }
  }
);

export const fetchProductsByCategory = createAsyncThunk(
  'productListing/fetchProductsByCategory',
  async ({ category, page = 1, limit = 10, search = '' }, { rejectWithValue, getState }) => {
    try {
      if (!category) {
        const result = await fetchProducts({ page, limit })(getState, rejectWithValue);
        return {
          ...result,
          categoryTitle: null
        };
      }

      const state = getState();
      const params = new URLSearchParams();

      params.append('page', page);
      params.append('per_page', limit);
      params.append('search', search);


      const categories = state.category?.categories || [];
      let selectedCategory;
      let categoryTitle = '';

      if (typeof category === 'number' || !isNaN(category)) {
        selectedCategory = categories.find(cat => cat.id.toString() == category.toString());
        categoryTitle = selectedCategory?.title || '';
      } else {
        selectedCategory = categories.find(cat =>
          cat.title?.toLowerCase() == category?.toLowerCase()
        );
        categoryTitle = category;
      }

      if (selectedCategory?.id) {
        params.append('category_id', parseInt(selectedCategory.id));
      }

      const queryString = params.toString();

      const response = await callAPIWithoutAuth(
        `${apiUrls.productListing}?${queryString}`,
        {},
        "GET",
        {}
      );

      if (response?.data?.success) {
        const apiData = response.data.data;

        const transformedProducts = apiData.data?.map(product => {
          let price = 0;
          let discountedPrice = 0;
          let variantType = '';
          let productImage = "";

          if (product.tyre_variants?.length > 0) {
            const variant = product.tyre_variants[0];
            price = variant.price;
            discountedPrice = variant.discounted_price;
            variantType = 'tyre';
            if (variant.images?.length > 0) {
              productImage = variant.images[0].image_url;
            }
            else {
              productImage = product.category.image_url
            }
          } else if (product.battery_variants?.length > 0) {
            const variant = product.battery_variants[0];
            price = variant.price;
            discountedPrice = variant.discounted_price;
            variantType = 'battery';
            if (variant.images?.length > 0) {
              productImage = variant.images[0].image_url;
            }
            else {
              productImage = product.category.image_url
            }
          } else if (product.windshield_variants?.length > 0) {
            const variant = product.windshield_variants[0];
            price = variant.price;
            discountedPrice = variant.discounted_price;
            variantType = 'windshield';
            if (variant.images?.length > 0) {
              productImage = variant.images[0].image_url;
            }
            else {
              productImage = product.category.image_url
            }
          }

          const discount = price > 0 && discountedPrice
            ? Math.round(((price - discountedPrice) / price) * 100)
            : 0;

          return {
            id: product.id,
            image: productImage,
            brand: product.brand?.name || "Unknown",
            brandImage: product.brand.image_url,
            name: product.name,
            badge: product.badge,
            img: product.category.image_url,
            rating: 4,
            reviews: 0,
            price: parseFloat(price) || 0,
            discount: discount,
            discountedPrice: discountedPrice,
            is_saved: product.is_saved || false,
            isFavorite: product.is_saved || false,
            category: product.category?.title?.toLowerCase() || "",
            tireSize: product.size?.name || "",
            carModel: product.model?.name || "",
            variantType: variantType,
            variants: product.tyre_variants || product.battery_variants || product.windshield_variants || []
          };
        }) || [];

        return {
          products: transformedProducts,
          totalResults: apiData.total || 0,
          currentPage: apiData.current_page || page,
          itemsPerPage: apiData.per_page || limit,
          totalPages: apiData.last_page || 1,
          categoryTitle: categoryTitle
        };
      } else {
        return rejectWithValue(response?.data?.message || 'Failed to fetch products by category');
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Network error');
    }
  }
);

const productListingSlice = createSlice({
  name: 'productListing',
  initialState: {
    products: [],
    filteredProducts: [],
    currentProduct: null,

    brands: [],
    carModels: [],
    tireSizes: [],

    selectedBrandId: null,
    modelsLoading: false,

    totalResults: 0,
    currentPage: 1,
    itemsPerPage: 10,
    totalPages: 0,

    activeFilters: {
      category: '',
      brand: '',
      model: '',
      tireSize: ''
    },
    activeSort: '',

    loading: false,
    productsLoading: false,
    filterOptionsLoading: false,
    productDetailsLoading: false,
    error: null,

    title: "Premium Tyres, Battery and Windshields for Every Journey",
    description: "Engineered for safety, comfort, and performance, our tyres deliver superior grip, long-lasting durability, and a smooth driving experience on all road conditions. Drive with confidence, no matter where the road takes you."
  },
  reducers: {
    setActiveFilters: (state, action) => {
      if (action.payload.brand !== undefined && action.payload.brand !== state.activeFilters.brand) {
        state.activeFilters.model = '';
        state.selectedBrandId = action.payload.brand;
      }

      state.activeFilters = {
        ...state.activeFilters,
        ...action.payload
      };
    },
    clearActiveFilters: (state) => {
      state.activeFilters = {
        category: '',
        brand: '',
        model: '',
        tireSize: ''
      };
      state.selectedBrandId = null;
      state.carModels = [];
    },
    setActiveSort: (state, action) => {
      state.activeSort = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setItemsPerPage: (state, action) => {
      state.itemsPerPage = action.payload;
    },
    clearProducts: (state) => {
      state.products = [];
      state.filteredProducts = [];
      state.totalResults = 0;
      state.currentPage = 1;
    },
    clearProductListingError: (state) => {
      state.error = null;
    },
    resetProductListingState: (state) => {
      state.products = [];
      state.filteredProducts = [];
      state.currentProduct = null;
      state.brands = [];
      state.carModels = [];
      state.tireSizes = [];
      state.totalResults = 0;
      state.currentPage = 1;
      state.itemsPerPage = 10;
      state.totalPages = 0;
      state.activeFilters = { category: '', brand: '', model: '', tireSize: '' };  // Updated
      state.activeSort = '';
      state.loading = false;
      state.error = null;
    },
    updateProductFavoriteInListing: (state, action) => {
      const { productId, isFavorite } = action.payload;

      state.products = state.products.map(product =>
        product.id == productId ? { ...product, isFavorite, is_saved: isFavorite } : product
      );

      state.filteredProducts = state.filteredProducts.map(product =>
        product.id == productId ? { ...product, isFavorite, is_saved: isFavorite } : product
      );

      if (state.currentProduct?.id == productId) {
        state.currentProduct = { ...state.currentProduct, isFavorite, is_saved: isFavorite };
      }
    },
    clearCategoryFilter: (state) => {
      state.activeFilters.category = '';
      state.currentPage = 1;
    },
    clearCarModels: (state) => {
      state.carModels = [];
    },

    clearAllFilters: (state) => {
      state.activeFilters = {
        category: state.activeFilters.category,
        brand: '',
        model: '',
        tireSize: ''
      };
      state.selectedBrandId = null;
      state.carModels = [];
      state.activeSort = '';
      state.currentPage = 1; 
    },
    setCategoryFilter: (state, action) => {
      state.activeFilters.category = action.payload;
      state.currentPage = 1;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProducts.pending, (state) => {
        state.productsLoading = true;
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProducts.fulfilled, (state, action) => {
        state.productsLoading = false;
        state.loading = false;
        state.products = action.payload.products;
        state.filteredProducts = action.payload.products;
        state.totalResults = action.payload.totalResults;
        state.currentPage = action.payload.currentPage;
        state.itemsPerPage = action.payload.itemsPerPage;
        state.totalPages = Math.ceil(action.payload.totalResults / action.payload.itemsPerPage);
        if (!state.activeFilters.category && !state.activeFilters.brand && !state.activeFilters.model && !state.activeFilters.tireSize) {
          state.title = "Premium Tyres, Battery and Windshields for Every Journey";
          state.description = "Engineered for safety, comfort, and performance, our tyres deliver superior grip, long-lasting durability, and a smooth driving experience on all road conditions. Drive with confidence, no matter where the road takes you.";
        }
      })
      .addCase(fetchProducts.rejected, (state, action) => {
        state.productsLoading = false;
        state.loading = false;
        state.error = action.payload || 'Failed to fetch products';
      })

      .addCase(fetchProductById.pending, (state) => {
        state.productDetailsLoading = true;
        state.error = null;
      })
      .addCase(fetchProductById.fulfilled, (state, action) => {
        state.productDetailsLoading = false;
        state.currentProduct = action.payload;
      })
      .addCase(fetchProductById.rejected, (state, action) => {
        state.productDetailsLoading = false;
        state.error = action.payload || 'Failed to fetch product details';
      })

      .addCase(fetchProductsByCategory.pending, (state) => {
        state.productsLoading = true;
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProductsByCategory.fulfilled, (state, action) => {
        state.productsLoading = false;
        state.loading = false;
        state.products = action.payload.products;
        state.filteredProducts = action.payload.products;
        state.totalResults = action.payload.totalResults;
        state.currentPage = action.payload.currentPage;
        state.itemsPerPage = action.payload.itemsPerPage;
        state.totalPages = Math.ceil(action.payload.totalResults / action.payload.itemsPerPage);
        if (action.payload.categoryTitle) {
          state.title = `${action.payload.categoryTitle} Products`;
          state.description = `Browse our collection of premium ${action.payload.categoryTitle.toLowerCase()} products`;
        } else {
          state.title = "Premium Tyres, Battery and Windshields for Every Journey";
          state.description = "Engineered for safety, comfort, and performance, our tyres deliver superior grip, long-lasting durability, and a smooth driving experience on all road conditions. Drive with confidence, no matter where the road takes you.";
        }
      })
      .addCase(fetchProductsByCategory.rejected, (state, action) => {
        state.productsLoading = false;
        state.loading = false;
        state.error = action.payload || 'Failed to fetch products by category';
      })

      .addCase(fetchBrands.pending, (state) => {
        state.filterOptionsLoading = true;
        state.error = null;
      })
      .addCase(fetchBrands.fulfilled, (state, action) => {
        state.filterOptionsLoading = false;
        state.brands = action.payload;
      })
      .addCase(fetchBrands.rejected, (state, action) => {
        state.filterOptionsLoading = false;
        state.error = action.payload || 'Failed to fetch brands';
      })

      .addCase(fetchTireSizes.pending, (state) => {
        state.filterOptionsLoading = true;
        state.error = null;
      })
      .addCase(fetchTireSizes.fulfilled, (state, action) => {
        state.filterOptionsLoading = false;
        state.tireSizes = action.payload;
      })
      .addCase(fetchTireSizes.rejected, (state, action) => {
        state.filterOptionsLoading = false;
        state.error = action.payload || 'Failed to fetch tyres sizes';
      })

      .addCase(fetchModelsByBrand.pending, (state) => {
        state.modelsLoading = true;
        state.error = null;
      })
      .addCase(fetchModelsByBrand.fulfilled, (state, action) => {
        state.modelsLoading = false;
        state.carModels = action.payload.models;
      })
      .addCase(fetchModelsByBrand.rejected, (state, action) => {
        state.modelsLoading = false;
        state.error = action.payload || 'Failed to fetch models';
      })

      .addCase(fetchFilterOptions.pending, (state) => {
        state.filterOptionsLoading = true;
        state.error = null;
      })
      .addCase(fetchFilterOptions.fulfilled, (state, action) => {
        state.filterOptionsLoading = false;
        state.brands = action.payload.brands;
        state.tireSizes = action.payload.tireSizes;
      })
      .addCase(fetchFilterOptions.rejected, (state, action) => {
        state.filterOptionsLoading = false;
        state.error = action.payload || 'Failed to fetch filter options';
      });
  }
});

export const {
  setActiveFilters,
  clearActiveFilters,
  setActiveSort,
  setCurrentPage,
  setCategoryFilter,
  setItemsPerPage,
  clearCategoryFilter,
  clearProducts,
  clearProductListingError,
  resetProductListingState,
  updateProductFavoriteInListing,
  clearCarModels,
  clearAllFilters
} = productListingSlice.actions;

export default productListingSlice.reducer;